module.exports = __webpack_public_path__ + "static/media/img6.c0a2af86.jpeg";